import { ISummary } from "./aiForm";

export type TSchoolSearchCondition = {
  OrgName: string;
  Zip: string;
  Country: string;
};

export type TSchoolSearchResult = any; // come from elastic search

export interface ISearchRecord {
  ai: TSchool,
  active?: ISummary,
  owned?: ISummary;
}

export type TSchool = {
  orgId: string;
  aiCode: string;
  aiName: string;
  orgName: string;
  orgAddress: string;
  orgCity: string;
  orgStateCode: string;
  orgCountryCode: string;
  orgProvince: string;
  orgPostalCode: string;
  orgZip: string;
  aiStatus: string;
  aiStatusCd: "1" | "2";
  aiLevelCd: "1" | "2";
  lowestGradeCd: string;
  highestGradeCd: string;
  aiCategoryCd: string;

};

export enum FormTypes {
  AIFORM = 'AIFORM',
  AIAFORM = 'AIAFORM',
  SUBMIT = 'SUBMIT',
  TESTINGPLAN = 'TESTINGPLAN',
}
